import { InjectionToken } from "@angular/core";
import { ISwitchCompanyModalService } from "./i-switch-company-modal.service";

export const switchCompanyModalServiceInjectionToken: InjectionToken<ISwitchCompanyModalService> = new InjectionToken<ISwitchCompanyModalService>("digital-signage.user-dashboard.dashboard-web.SwitchCompanyModalService");
